import { render, staticRenderFns } from "./CateringDescription.vue?vue&type=template&id=a7f7008a&scoped=true&"
import script from "./CateringDescription.vue?vue&type=script&lang=js&"
export * from "./CateringDescription.vue?vue&type=script&lang=js&"
import style0 from "./CateringDescription.vue?vue&type=style&index=0&id=a7f7008a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f7008a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTextarea,VTooltip})
